// 数字转换为千分位
export function thousandFn(num) {
  if (num) {
    num = num.toString().replace(/\$|\,/g, '')
    // if (num == '' || isNaN(num)) { return 'Not a Number!' }
    if (num == '' || isNaN(num)) { return num }
    var sign = num.indexOf('-') > 0 ? '-' : '' // 符号
    var cents = num.indexOf('.') ? num.substr(num.indexOf('.')) : '' // 小数部分
    cents = cents.length > 1 ? cents : ''
    num = num.indexOf('.') > 0 ? num.substring(0, num.indexOf('.')) : num // 整数部分
    if (cents == '') {
      if (num.length > 1 && num.substr(0, 1) == '0') { return 'Not a Number!' }
    }
    for (var i = 0; i < Math.floor((num.length - (i + 1)) / 3); i++) {
      num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
    }
    var numt = sign + num + cents
    if (numt.indexOf('-') > -1 && numt.charAt(1) == ',')numt = numt.replace(',', '')
    return numt
  }
}
